






















import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderButton from "@/components/builder/BuilderButton.vue"

type positionBlock = 'start' | 'center' | 'end'

type widthBlock = 'small' | 'normal' | 'large' | 'larger'

@Component({
  components: {
    BuilderButton
  }
})
export default class BuilderSidebar extends Vue {
  @Prop({ default: 'none', type: String }) private position!: positionBlock

  @Prop({ default: 'none', type: String }) private blockWidth!: widthBlock

  @Prop({default: false, type: Boolean}) private showBtnCloseMenu!: boolean


  get blockPosition(): string {
    switch (this.position) {
      case 'start':
        return 'flex items-start'
      case 'center':
        return 'flex items-center'
      case 'end':
        return 'flex items-end'
      default:
        return 'none'
    }
  }

  get blockofWidth(): string {
    switch (this.blockWidth) {
      case 'small':
        return 'w-mobile-container-page-desc'
      case 'normal':
        return 'w-tablet-container-page-desc'
      case 'large':
        return 'w-desktop-container-page-desc'
      case 'larger':
        return 'w-steps-description-larger'
      default:
        return 'none'
    }
  }
  handlerClickBtnCloseMenu(): void {
    this.$store.dispatch('app/changeVisibilityMenu', false)
  }
}
